import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Category from "../pages/category/page";
import ComicDetail from "../pages/comic/page";
import About from "../pages/about/page";
import Search from "../pages/search/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/category/all",
    element: <Category />,
  },
  {
    path: "/category/:slug",
    element: <Category />,
  },
  {
    path: "/comic/:slug",
    element: <ComicDetail />,
  },
  {
    path: "/about",
    element: <About />,
  },
  {
    path: "/search",
    element: <Search />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;